/**
 * Module dependencies.
 */

import React from 'react';

/**
 * `Props` type.
 */

type Props = {
  item: any;
  openSync: (item: any) => void;
};

/**
 * Export `NeedUpdate` component.
 */

export function NeedUpdate({ item, openSync }: Props): JSX.Element | null {
  if (!item.sync || !item.sync.needSync) {
    return null;
  }

  return (
    <div
      className={
        'absolute left-2 top-[9px] flex h-5 w-5 items-center justify-center rounded-full bg-[red] text-sm font-bold text-white'
      }
      onClick={event => {
        event.stopPropagation();
        event.preventDefault();

        openSync(item);
      }}
    >
      {'!'}
    </div>
  );
}
